import PublicLayout from "@/components/layout/PublicLayout";
import { Link } from "react-router-dom";
import { Upload, BarChart3, FileCheck2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function HoeWerktHet() {
  return (
    <PublicLayout>
      <section className="oc-section">
        <div className="oc-container">
          <div className="max-w-3xl">
            <span className="text-[13px] uppercase tracking-[0.1em] font-semibold text-oc-secondary">Het proces</span>
            <h1 className="font-display font-bold text-[40px] sm:text-[52px] leading-tight tracking-tight text-oc-primary mt-3">
              Hoe werkt OfferteExpert?
            </h1>
            <p className="mt-5 text-oc-textSecondary text-[18px] leading-relaxed">
              Een eerlijke offertecheck moet eenvoudig en snel zijn. Geen formulieren, geen lange wachttijden. Hieronder leggen we het volledige proces uit.
            </p>
          </div>

          <div className="mt-16 grid lg:grid-cols-3 gap-6">
            {[
              { n: "01", icon: Upload, t: "Upload of plak je offerte", d: "PDF, foto of getypte tekst — alles werkt. Onze server haalt automatisch alle relevante posten en bedragen uit het document." },
              { n: "02", icon: BarChart3, t: "Wij vergelijken elke lijnpost", d: "Voor elke post zoeken we relevante referentieprijzen in jouw regio. Materiaal en arbeid worden gescheiden bekeken." },
              { n: "03", icon: FileCheck2, t: "Ontvang je rapport", d: "Je krijgt een score (0-100), een heatmap, een uitleg per post en concrete onderhandelingstips. Plus een PDF om te bewaren." },
            ].map((s, i) => {
              const Icon = s.icon;
              return (
                <div key={i} className="bg-white rounded-oc border border-oc-border p-9">
                  <span className="font-mono text-oc-textSecondary text-[13px]">{s.n}</span>
                  <div className="w-12 h-12 rounded-xl bg-oc-subtle flex items-center justify-center mt-3">
                    <Icon className="w-5 h-5 text-oc-primary" />
                  </div>
                  <h3 className="mt-6 font-display font-semibold text-oc-primary text-[20px]">{s.t}</h3>
                  <p className="mt-2 text-oc-textSecondary leading-relaxed">{s.d}</p>
                </div>
              );
            })}
          </div>

          <div className="mt-16 bg-white rounded-oc border border-oc-border p-10 grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="font-display font-bold text-oc-primary text-[28px]">Wat zit er in je rapport?</h2>
              <ul className="mt-4 space-y-2.5 text-oc-textPrimary leading-relaxed text-[15px] list-disc pl-5">
                <li>Score van 0 tot 100 met directe duiding</li>
                <li>Marktprijs per lijnpost (min – max bereik)</li>
                <li>Statuslabel per post: eerlijk, hoog, overdreven</li>
                <li>3 concrete onderhandelingstips</li>
                <li>Positieve punten over je offerte</li>
                <li>BTW-controle (6% of 21%)</li>
                <li>PDF-rapport om te downloaden of te delen</li>
              </ul>
            </div>
            <div className="bg-oc-subtle border border-oc-border rounded-oc p-7 text-center">
              <p className="text-oc-textSecondary text-[13px] uppercase tracking-[0.1em] font-semibold">Klaar om te starten?</p>
              <p className="font-mono text-oc-primary font-semibold mt-3 text-[40px] leading-none">€ 4,99</p>
              <p className="text-oc-textSecondary mt-2 text-[14px]">Eenmalig, geen abonnement</p>
              <Link to="/analyse">
                <Button className="mt-6 w-full h-12 bg-oc-primary hover:bg-oc-secondary text-white rounded-oc-btn font-semibold">
                  Probeer het zelf <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
